export default "__VITE_ASSET__DNbt2EgY__"